import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/recovery/page.jsx");
